// extracted by mini-css-extract-plugin
module.exports = {"detail":"detail--22klDUNct","changed":"changed--3By0hWH4E"};